import { AssignedWorkflow, AvailableWorkflowTemplate } from 'data/models/Workflows';
import { RootState } from 'data/store';

export const selectAvailableWorkflowTemplates = (state: RootState): AvailableWorkflowTemplate[] => state.workflows.availableWorkflowTemplates;
export const selectAvailableWorkflowTemplatesIsLoading = (state: RootState): boolean => state.workflows.isAvailableWorkflowTemplatesLoading;

export const selectAssignedWorkflows = (state: RootState): AssignedWorkflow[] => state.workflows.assignedWorkflows;
export const selectAssignedWorkflowsLoading = (state: RootState): boolean => state.workflows.isAssignedWorkflowsLoading;

export const selectHouseholdHeaderAssignedWorkflows = (state: RootState): AssignedWorkflow[] => state.workflows.householdHeaderAssignedWorkflows;
export const selectHouseholdHeaderAssignedWorkflowsLoading = (state: RootState): boolean => state.workflows.isHouseholdHeaderAssignedLoading;

export const selectIsAssignedWorkflowInStore =
  (workflowId: number | undefined) =>
  (state: RootState): boolean => {
    if (!workflowId) return false;
    const { assignedWorkflows, householdHeaderAssignedWorkflows } = state.workflows;
    return [...assignedWorkflows, ...householdHeaderAssignedWorkflows].some(workflow => workflow.id === workflowId);
  };
